import React, { ReactNode } from 'react';

interface IconProps {
  icon: ReactNode;
  className?: string;
}

/**
 * A wrapper component that renders any ReactNode icon
 * This helps with type compatibility for react-icons
 */
const Icon: React.FC<IconProps> = ({ icon, className = '' }) => {
  return <span className={className}>{icon}</span>;
};

export default Icon;